
import { v4 as uuidv4 } from "uuid";
import React from "react";

const SessionContext = React.createContext('sessionid-' + uuidv4());
export { SessionContext as default };